// extracted by mini-css-extract-plugin
export default {"root":"BatchBox_root__x-tsw","head-container":"BatchBox_head-container__eTQ4X","header":"BatchBox_header__DyqsV","date":"BatchBox_date__2OECl","duration":"BatchBox_duration__3iRTz"};